import { ILocalization } from './localization-interface';

export const defaultLocalization: ILocalization = {
    commonLoc: {
        loading: "Loading...",
        saving: "Saving...",
        accept: "Accept",
        back: "Back",
        statusTitle: "Status",
        close: "Close",
        motive: "Motive",
        logo: "Logo",
        error: "Error",
        controlsLinkValue: "https://www.promotron.com/download/PromoTron_TronLogo_Customer-Manual_EN.pdf",
        save: "Save"
    },
    galleryLoc: {
        uploadNewLogo: "Upload new logo",
        galleryTitle: "Your Logo & Motive Gallery",
        galleryInfo: "Click for change and active one of your logos / motives for visualization:",
        loadFailedTtile: "Failed to load logos",
        loadFailedMessage: "Sorry, loading of your logos failed.",
        deleteFailedTtile: "Delete failed",
        daleteFailedMessage: "Failed to delete logo",
        controlsLinkTitle: "Help",
        defaultLogoSeparator: "Default logos",
        deleteLogoDialog: {
            title: "Delete logo?",
            content: "Are you sure you want delete this logo?",
            keepBtn: "Keep",
            deleteBtn: "Delete"
        },
        logoImageHint: "Activates logo for visualization in entire E-shop",
        clearSelectedLogo: "Clear selected logo"
    },
    uploadLoc: {
        title: "Upload New Logo",
        uploadScreen: {
            info1: "For best quality and faster print-proof process please upload logo in vectors and Pantone colors.",
            formatsRecommended: "Recommended formats",
            formatsRaster: "Raster formats",
            formatsForbidden: "Forbidden formats",
            jpgInfo: "Not supported.",
            dragDropInfo: "Drag & Drop file from your PC",
            dragOrClick: "or",
            clickInfo: "Choose logo file",
            limitsSize: "Max. file size",
            limitsVector: "Vector",
            limitsRaster: "Raster",
            dragOverlayMsg: "Drop your logo here to start upload",
            optionFull: "Remove all background",
            optionNone: "Remove background only from edges",
            optionEdge: "Don't remove background"
        },
        progressUpl: {
            failExtension: "FAILED - Uploaded unsupported format ({0}). Please upload supported file format ...",
            failTooBig: "FAILED - File is too large. Please upload file with size less than {0}MB ...",
            failServer: "FAILED - File processing ended with error",
            fail: "FAILED - File was not uploaded",
            uploading: "Uploading",
            progress: "Processing",
            completed: "Completed"
        },
        logoPreview: {
            failedToAddLogo: "Failed to add logo to gallery",
            dtpInfo: "Please <b>leave us your e-mail</b> - our DTP workers will check uploaded file and try to export logo with highest quality by Adobe/Corel sofwtare. You will recieve e-mail with notification that your logo is available in gallery in 5-15 minutes in working time ...",
            info: "Please check processed logo and <b>automatically generated WHITE and BLACK variant</b> for visualization. If any of variants is WRONG or you don't use White or Black variant of your logo, just click to button WRONG. Immediatelly after confirmation you will see <b>uploaded logo on thousands of products ...</b>",
            confirmBtn: "CONFIRM NEW LOGO"
        },
        logoConfirm: {
            variantOrg: "ORIGINAL COLOR variant",
            variantWhite: "WHITE variant",
            variantBlack: "BLACK variant",
            logoOk: "OK",
            logoWrong: "WRONG",
            variantNotAcceptedOverlay: "This variant will not be used.",
            logoNotAcceptedOverlay: "Logo is WRONG"
        },
        dtpRequest: {
            stateNotStarted: "SEND FILE FOR MANUAL PREPARE",
            stateSending: "SENDING...",
            stateFailed: "FAILED!",
            stateCompleted: "COMPLETED",
            placeholder: "E-mail Address"
        },
        dtpResult: {
            backToGallery: "Back to Gallery",
            msgSucess: "Notification was successfully sent to our DTP workers! Now just wait for e-mail and uploaded file will be added to your gallery ...",
            msgFail: "We are sorry, sending notification to our DTP workers failed! Please contact us at tronlogo@promotron.com"
        },
        uploadFailed: {
            msgFail: "We are sorry, processing uploaded file and preparing logo for visualization failed!",
            msgDtp: "If you <b>ARE SURE</b> that file is correct, please <b>leave us your e-mail</b> - our DTP workers will check and try to open uploaded file in Adobe/Corel and export logointo supported format with highest quality. You will recieve e-mail with notification that your logo is available in gallery in 5-15 minutes in working time ...",
            btnRepeatUpload: "REPEAT UPLOAD"
        },
        ProcessMessages: {
            GenerateBlackVersion: "Generating BLACK version...",
            GenerateWhiteVersion: "Generating WHITE version...",
            LogoReplace: "Logo replace started...",
            BadFileFormat: "Bad file format!",
            StoreLogo: "Storing logo to database...",
            CropImage: "Cropping empty space...",
            ConversionFailed: "Conversion to raster FAILED!",
            FileConverting: "Converting file...",
            StoreOriginalLogo: "Storing original logo to database...",
            UploadingFile: "Uploading file...",
            Unauthorized: "Unauthorized!",
            UrlNotValid: "Request url is not valid!",
            MissingData: "Missing file data!",
            InvalidExtension: "Invalid or missing file extension!",
            GeneralError: "Processing logo failed",
            CropFailed: "Cropping image FAILED!",
            GeneratingColorVariantsFailed: "Generating color variants FAILED!",
            ProcessingTimeout: "Processing ended due to timeout!"
        }
    },
    editorLoc: {
        title: "Print Editor",
        galleryInfo: "Select logo to be added to your motive",
        logoEditorContent: {
            continueButton: "CONTINUE",
            saveToGalleryButton: "Use for all",
            printAreaSize: "Max print size: {0} x {1} mm",
            motiveAreaSize: "Motive size: {0} x {1} mm ({2} cm2)",
            logoOriginal: "Original",
            logoWhite: "White",
            logoBlack: "Black",
            logoCustom: "Custom",
            textDefault: "Your Text",
            galleryDialogTitle: "Logo gallery",
            closeEditorButton: "Close Editor",
            inicializationFailedTitle: "Failed to prepare visualization editor",
            inicializationFailedServerError: "Error: Failed to retrieve data from server!",
            inicializationFailedNoVisualization: "Error: missing visualization data!",
            loadImageError: "We are sorry, there is some error with loading your logo, Please try upload new logo to gallery...",
            savingMotiveDialog: "Please wait, we are generating Black & White variant of your Motive and adding all to your gallery...",
            savingMotiveDialogTitle: "Save Motive to Gallery",
            savingMotiveErrorDialogMsg: "We are sorry, there is some error with saving your motive to gallery. Please try it again later.",
            sendPreviewSuccessDialogTitle: "<b>E-mail with PDF proofreading has been successfully sent to your e-mail.</b>",
            sendPreviewSuccessDialogMsg: "Now you can close browser and if you return later, your motive will be reloaded and you will be able to finish approving to production.",
            editorLoadingDialogTitle: "Editor loading",
            editorLoadingDialogMsg: "Please wait, editor is loading...",
            recentColorsLabel: "Recently used colors",
            motiveColorsLabel: "Motive colors",
            galleryUploadButton: "Upload LOGO",
            clearProductMotiveTitleDialog: "Remove product motive",
            clearProductMotiveContentDialog: "Removes motive related to product and apply globaly selected motive",
            saveMotiveDialogTitle: "Select how to save and use your motive",
            saveMotiveDialogOptionForProduct: "Save motive only for this product",
            saveMotiveDialogOptionForAll: "Save motive for this product<br/> Add motive to my gallery<br/> Show motive on all products<br/>",
            savePng: "Save as PNG",
            noPrintTechnologies: "<b>Print technologies are not specified.</b><br/>Active is basic visualization without colors checking.",
            maxMotiveColors: "Max print colors: {0}",
            actualMotiveColors: "Colors in motive: {0}",
            colorlessTechnology: "Motive will have<br/> only <b>1 color<b/>",
            printPositionLabel: "Position: {0}",
            printTechnologyLabel: "Technology: {0}",
            controlHints: {
                editorHintLabel: "<b>Mouse wheel</b> - zoom print area | <b>Spacebar + left mouse</b> - move print area | <b>Ctrl + R</b> for reset view | <b>DEL</b> for delete active object."
            },
            toolTips: {
                addLogo: "Add logo from gallery",
                addText: "Add text",
                addLine: "Add line",
                addRectangle: "Add rectangle",
                undo: "UNDO",
                redo: "REDO",
                toggleMagnet: "Toggle magnet",
                showHelp: "Show help",
                textValue: "Text",
                textFont: "Font",
                textFontSize: "Font size",
                textAlign: "Text align",
                textToggleBold: "Toggle bold",
                textToggleItalic: "Toggle italic",
                textColor: "Text color",
                lineStrokeColor: "Line color",
                lineStrokeWidth: "Line width",
                rectFillColor: "Fill color",
                rectStrokeColor: "Stroke color",
                rectStrokeWidth: "Stroke width",
                logoOriginalTip: "Logo in original color",
                logoWhiteTip: "Logo in white variant",
                logoBlackTip: "Logo in black variant",
                logoCustomTip: "Logo in custom color",
                saveMotive: "Your motive will be saved to gallery for later activation and visualization on products",
                continue: "System will generate PROOFREADING and show it to you. You will be able to send it as PDF to your e-mail or make final confirmation = approve it to production and send visualization to our Sales Department (after it you can finish order of products and we will join it together)",
                clearProductMotive: "Click to remove motive related to product and apply globaly selected motive",
                savePngTip: "Saves visualization as PNG image",
                colorsExceeded: "Motive contains too many colors to be printed with current technology"
            },
            proofreading: {
                title: "Proofreading",
                colorWarnLine1: "<p><b>Warning</b>: The colors displayed on your monitor may differ from the real colors of the logotype due to monitor settings.</p><p>Colors (Pantone / CMYK) will be used from your uploaded source materials.</p>",
                emailPlaceholder: "Email Address",
                emailLabel: "Your e-mail:",
                emailErrorMsg: "E-mail address invalid",
                sendConfirm: "I APPROVE TO PRODUCTION",
                infoText: "<p><b>When you confirm and approve visualization for production, all data will be send to our Sales Department.</b></p><p>After confirmation you can finish your product order in e-shop and we join visualization and order together via your e-mail.</p><p><b>Our DTP department will check all data</b> (logo quality, colors, technology limits etc.) and if everything will be OK, we finally prepare PRINT data and automatically start production.</p><p><b>If there will be any problem, we will contact you and new proofreading process will start</b> (this approving will be canceled).</p><p><alert><b>PLEASE CHECK CAREFULLY THIS PROOFREADING!</b> Claims for products made according to the approved visualization will not be accepted!</alert></p>",
                sendErrorTitle: "Generate Proofreading to PDF failed!",
                sendErrorMsg: "We are sorry, there is some error with generating proofreading to PDF. Please try it again later.",
                generatingPdf: "Please wait, we are generating PDF with proofreading ...",
                saveMotiveCheckbox: "Save motive to gallery"
            }
        },
        brandingTechnology: {
            SCREENPRINT: "Screenprint",
            SCREENTRANSFER: "Screenprint transfer",
            PADPRINT: "Pad print",
            DIGITALUV: "Digiprint UV",
            DIGITALTRANSFER: "Digital transfer",
            EMBOSSBLIND: "Blind embossing",
            EMBOSSFOLIO: "Folio embossing",
            EMBROIDERY: "Embroidery",
            LASER: "Laser engraving",
            DOMING: "Doming",
            FIRINGCERAMIC: "Firing on ceramics",
            FIRINGFLEECE: "Firing into fleece",
            SANDING: "Sandblasting",
            SUBLIMATION: "Sublimation",
            UNKNOWN: "Standard print"
        }
    }
}



// WEBPACK FOOTER //
// ./src/App/shared/localization/default-localization.tsx